import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const transactionMonitoringRulesColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Rule name',
  },
  {
    name: 'action',
    label: 'Action',
  },
  {
    name: 'active',
    label: 'Status',
  },
  {
    name: 'createdAt',
    label: 'Date added',
  },
];

export const transactionMonitoringRulesColumnsLabels = {
  active: 'Status',
};

export const transactionMonitoringRulesDefaultSorter = {};

export const transactionMonitoringRulesSchema = {
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  organizationIds: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const transactionMonitoringRulesFiltersSchema = [
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
];
